import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useTasks } from "../hooks/useTasks";
import { useSelector } from "react-redux";
import CalendarCard from "../components/CalendarCard";
import TaskListCard from "../components/TaskListCard";
import TaskDetailsModal from "../components/TaskDetailsModal";
import StudentSelectorWrapper from "../../../../components/Peoples/guardian/StudentSelectorWrapper";
import { useEffectiveStudentId } from "../../../../components/Peoples/guardian/hooks/useEffectiveStudentId";
import PageHeader from "components/Common/PageHeader";
import CalendarFilter from "../components/CalendarFilter";
import { RootState } from "redux/store";
import { ClassTask } from "types/classTaskTypes";
import AttachmentPreviewModal from "../components/AttachmentPreviewModal";


const StudentTaskPage: React.FC = () => {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedTask, setSelectedTask] = useState<any | null>(null);
  const isStudent = useSelector((state: RootState) => state.authSlice.user?.role === "student");
  const studentId = useEffectiveStudentId();
  const [attachmentModalVisible, setAttachmentModalVisible] = useState(false);
  const [attachmentUrls, setAttachmentUrls] = useState<string[]>([]);

  const { tasks, loading, error, setFilters } = useTasks({ studentId });

  const handleDateSelect = (date: any) => {
    const formattedDate = date ? date.format("YYYY-MM-DD") : null;
    setSelectedDate(formattedDate);
  };

  const handleTaskClick = (task: any) => {
    setSelectedTask(task);
    setModalVisible(true);
  };
  const handleShowAttachments = (task: ClassTask) => {
    const urls: string[] = task.attachments ?? []
    setAttachmentUrls(urls);
    setAttachmentModalVisible(true);
  };

  // Refresh tasks when studentId changes
  useEffect(() => {
    if (studentId) {
      setFilters({ studentId });
    }
  }, [studentId, setFilters]);

  const breadcrumbItems = [
    { label: "dashboard", path: "/dashboard" },
    { label: "homework_diary", active: true }
  ];

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <PageHeader
          title={t("homework_diary")}
          breadcrumbItems={breadcrumbItems}
        />

        <div >
          <div >
            <StudentSelectorWrapper
              rightSlot={
                <CalendarFilter
                  onDateSelect={handleDateSelect}
                  tasks={tasks.filter(task => !!task.date).map(task => ({ date: String(task.date) }))}
                />}
            >
              {studentId ? (
                <>
                  {isStudent && (
                    <div className="mb-3 d-flex justify-content-end">
                      <CalendarFilter
                        onDateSelect={handleDateSelect}
                        tasks={tasks.filter(task => !!task.date).map(task => ({ date: String(task.date) }))}
                      />
                    </div>
                  )}
                  <div >
                    <TaskListCard
                      selectedDate={selectedDate}
                      tasks={selectedDate ? tasks.filter(task => task.date === selectedDate) : tasks}
                      loading={loading}
                      error={error}
                      onTaskClick={handleTaskClick}
                      onShowAttachments={handleShowAttachments}

                    />
                  </div>

                  {/* Homework Details Modal */}
                  <TaskDetailsModal
                    isOpen={modalVisible}
                    onClose={() => setModalVisible(false)}
                    selectedTask={selectedTask}
                    loading={loading}
                  />

                  <AttachmentPreviewModal
                    visible={attachmentModalVisible}
                    onClose={() => setAttachmentModalVisible(false)}
                    attachments={attachmentUrls}
                  />
                </>
              ) : (
                <p className="text-danger">{t("select_student_first")}</p>
              )}
            </StudentSelectorWrapper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentTaskPage;
